import Leaderboard from './Leaderboard.vue'

export default Leaderboard
